import { UserTypes } from '@/constant';

export interface ActivityLogQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  userId?: string;
  userType?: UserTypes;
  activityType?: ActivityLogType;
  entityType?: 0 | 1;
  entityId?: string;
  startDate?: string;
  endDate?: string;
  exportedAt?: number;
}

export interface Roles {
  roles: {
    display_name: string;
  }[];
}

export interface ActivityLog {
  user: Roles;
  id: string;
  user_id: string;
  user_type: UserTypes;
  user_name: string;
  activity_type: ActivityLogType;
  description: string;
  entity_type: 0 | 1;
  entity_id: string;
  metadata: Record<string, unknown>;
  ip_address: string;
  user_agent: string;
  created_at: string;
  roles: {
    display_name: string;
  }[];
}

export interface ActivityLogResponse {
  total_items: number;
  current_page: number;
  total_pages: number;
  data: ActivityLog[];
}

export enum ActivityLogType {
  // Authentication
  LOGIN = 1,
  LOGIN_FAILED = 2,
  LOGOUT = 3,
  REGISTER = 4,
  PASSWORD_RESET = 5,
  PASSWORD_CHANGE = 6,
  ACCOUNT_UPDATE = 7,
  EMAIL_VERIFICATION_REQUEST = 8,
  EMAIL_VERIFIED = 9,
  PASSWORD_RESET_REQUEST = 10,
  // User Management
  USER_CREATED = 11,
  USER_UPDATED = 12,
  USER_ACTIVATED = 13,
  USER_DEACTIVATED = 14,
  USER_DELETED = 15,
  PDF_EXPORT = 16,
  REGISTER_FAILED = 17,
  // Harbor Management
  HARBOR_CREATED = 18,
  HARBOR_UPDATED = 19,
  HARBOR_DELETED = 20,
  HARBOR_UPDATED_BY_REGION_OPERATOR = 21,

  // Feedback Management
  FEEDBACK_SUBMITTED = 22,
  FEEDBACK_EXPORTED = 23,
  FEEDBACK_UPDATED = 24,
  FEEDBACK_ROUTED = 25,
  // Featured Listings
  FEATURED_LISTING_UPDATED = 26,
  // Route Management
  ROUTE_CREATED = 27,
  // Boat Management
  BOAT_CREATED = 28,
  BOAT_UPDATED = 29,
  BOAT_DELETED = 30,
  // Route Save
  ROUTE_SAVED = 31,
  SEA_ROUTE_CALCULATED = 32,
  // Sea Route Management
  SEA_ROUTE_CREATED = 33,
  GDPR_CONSENT = 34,
  // export control
  EXPORT_CONTROL = 35,

  // CMS Management
  CMS_PAGE_UPDATED = 36,
  CMS_CONTENT_UPDATED = 37,
  CMS_CONTENT_DELETED = 38,

  // export control
  CREATE,
  UPDATE,
  DELETE,

  // Region
  REGION_CREATED = 39,
  REGION_UPDATED = 40,
  REGION_DELETED = 41,

  //poi
  POI_CREATE = 42,
  POI_UPDATE = 43,
  POI_DELETE = 44,

  // Club Management
  CLUB_CREATED = 45,
  CLUB_UPDATED = 46,
  CLUB_DELETED = 47,

  // berth category
  BERTH_CATEGORY_CREATED = 48,
  BERTH_CATEGORY_UPDATED = 49,
  BERTH_CATEGORY_DELETED = 50,

  BERTH_CREATE = 51,
  BERTH_UPDATE = 52,
  BERTH_DELETE = 53,

  BOOKING_CREATE = 54,
  BOOKING_UPDATE = 55,
  BOOKING_DELETE = 56,

  // addon
  ADDON_CREATE = 57,
  ADDON_UPDATE = 58,
  ADDON_DELETE = 59,

  // berth group
  BERTH_GROUP_UPDATE = 60,
  BERTH_GROUP_DELETE = 61,

  // community
  COMMUNITY_CREATED = 62,
  COMMUNITY_UPDATED = 63,
  COMMUNITY_DELETED = 64,
  USER_JOINED_COMMUNITY = 65,
  USER_REQUESTED_COMMUNITY_JOIN = 66,

  //post
  COMMENT_CREATED = 67,
  POST_CREATED = 68,
  POST_LIKED = 69,
  POST_UNLIKED = 70,
  POST_REPORTED = 71,
  POST_MODERATED = 72,
  POST_DOWNLOADED = 73,
  POST_UPDATED = 74,
  POST_DELETED = 75,
  COMMUNITY_USERS_LISTED = 76,
  COMMUNITY_JOIN_APPROVED = 77,
  COMMUNITY_JOIN_REJECTED = 78,
  USER_REMOVED_FROM_COMMUNITY = 79,

  USER_BLOCKED_IN_COMMUNITY = 80,
  COMMUNITY_JOIN_REQUEST = 81,
  COMMUNITY_JOIN_REQUEST_UPDATED = 82,
  BOOKING_CANCEL = 83,

  //pier
  PIER_CREATED = 84,
  PIER_UPDATED = 85,
  PIER_DELETED = 86,

  // Notification
  NOTIFICATION_SENT = 87,
  NOTIFICATION_READ = 88,
  NOTIFICATION_DELETED = 89,

  //Club approve:
  CLUB_APPROVE = 90,
  CLUB_REJECT = 91,

  // Berth Unavailability
  BERTH_UNAVAILABILITY = 92,

  // Harbor Favorites
  HARBOR_FAVORITED = 93,
  HARBOR_UNFAVORITED = 94,

  ORGANIZATION_CREATE = 95,
  ORGANIZATION_UPDATE = 96,
  ORGANIZATION_DELETE = 97,

  HARBOR_DELETION_REQUESTED = 98,
  HARBOR_DELETION_APPROVED = 99,
  HARBOR_DELETION_REJECTED = 100,
  HARBOR_RECOVERED = 101,

  DEPLOYMENT_CONFIRMED = 102,
  DEPLOYMENT_REJECTED = 103,

  SERVICE_PROVIDER_CREATE = 104,
  SERVICE_PROVIDER_UPDATE = 105,
  SERVICE_PROVIDER_DELETE = 106,

  // Harbor Association
  HARBOR_ASSOCIATION_REQUESTED = 107,
  HARBOR_ASSOCIATION_APPROVED = 108,
  HARBOR_ASSOCIATION_REJECTED = 109,
  HARBOR_ASSOCIATION_CANCELLED = 110,
  HARBOR_ASSOCIATION_REMOVED = 111,

  // third party service
  FEED_CONTROL_CHANGE = 112,
  // Subscription
  SUBSCRIPTION_CREATED = 113,
  USER_SUBSCRIBED = 114,
  SUBSCRIPTION_CANCELLED = 115,

  //subscription plan
  PLAN_CREATED = 116,
  PLAN_UPDATED = 117,
  PLAN_DELETED = 118,
  PLAN_PERMISSIONS_UPDATED = 119,

  //coupon
  COUPON_CREATED = 120,
  COUPON_UPDATED = 121,
  COUPON_DELETED = 122,

  // Club Resource Management
  CLUB_RESOURCE_CREATED = 123,
  CLUB_RESOURCE_UPDATED = 124,
  CLUB_RESOURCE_DELETED = 125,

  SUBMIT_CONTACT_FORM = 126,
  YATCH_CLUB_ADMIN_CREATED = 127,
  COMMENT_LIKE = 128,
  COMMENT_UNLIKE = 129,

  SEA_ROUTE_UPDATED = 130,
  TRANSACTION_CREATED = 131,
  KPI_LOGS = 132,

  CLUB_SHIFT_CREATED = 133,
  CLUB_SHIFT_ASSIGNED = 134,
  CLUB_SHIFT_UNASSIGNED = 135,
  CLUB_SHIFT_COMPLETED = 136,

  CLUB_RESOURCE_BOOKING_CREATED = 137,
  CLUB_RESOURCE_BOOKING_UPDATED = 138,
  CLUB_RESOURCE_BOOKING_CANCELLED = 139,
  RETURNED_KEYS = 140,

  CLUB_INSPECTION_ASSIGNED = 141,
  CLUB_INSPECTION_COMPLETED = 142,

  COUPON_VALIDATED = 143,

  // Service Request
  SERVICE_REQUEST_CREATED = 144,
  SERVICE_REQUEST_UPDATED = 145,
  SERVICE_REQUEST_APPROVED = 146,
  SERVICE_REQUEST_REJECTED = 147,
  SERVICE_REQUEST_STATUS_UPDATED = 148,

  // POI Request
  POI_REQUEST_CREATED = 149,
  POI_REQUEST_UPDATED = 150,
  POI_REQUEST_DELETED = 151,
  POI_REQUEST_APPROVED = 152,
  POI_REQUEST_REJECTED = 153,
  POI_REQUEST_VIEWED = 154,
  POI_REQUEST_VIEWED_ALL = 155,

  // Service Provider
  SERVICE_PROVIDER_CREATED = 156,
  SERVICE_PROVIDER_UPDATED = 157,
  SERVICE_PROVIDER_DELETED = 158,
  SERVICE_PROVIDER_APPROVED = 159,
  SERVICE_PROVIDER_REGISTERED = 160,

  // Advertisement Management
  AD_CREATED = 161,
  AD_UPDATED = 162,
  AD_DELETED = 163,
  AD_SLOT_CREATED = 164,
  AD_SLOT_UPDATED = 165,
  AD_SLOT_DELETED = 166,
  AD_CREATIVE_CREATED = 167,
  AD_CREATIVE_UPDATED = 168,
  AD_CREATIVE_DELETED = 169,

  AD_IMPRESSION = 170,
  AD_CLICK = 171,

  EMAIL_TEMPLATE_UPDATE = 176,
  NOTIFICATION_TEMPLATE_UPDATE = 177,

  // Service Booking
  SERVICE_BOOKING_CREATED = 178,
  SERVICE_BOOKING_UPDATED = 179,
  SERVICE_BOOKING_CANCELLED = 180,
  SERVICE_BOOKING_COMPLETED = 181,
  SERVICE_BOOKING_APPROVED = 182,
  SERVICE_BOOKING_REJECTED = 183,

  SUBSCRIPTION_REMAINDER = 184,
  SUBSCRIPTION_EXPIRED = 185,

  //service management
  SERVICE_CREATED = 186,
  SERVICE_UPDATED = 187,
  SERVICE_DELETED = 188,
  SERVICE_VISIBILITY_UPDATED = 189,
  SERVICE_SUBMITTED = 190,
  SERVICE_WITHDRAWN = 191,

  TEMPLATE_LAYOUT_UPDATE = 192,

  // Manual Annotation
  MANUAL_ANNOTATION_UPLOADED = 193,
  MANUAL_ANNOTATION_RETRIEVED = 194,
  MANUAL_ANNOTATION_DELETED = 195,
  MANUAL_ANNOTATION_LISTED = 196,
  MANUAL_ANNOTATION_PUBLISHED = 197,
  MANUAL_ANNOTATION_EDITER = 331,

  // Community event comments
  EVENT_COMMENTED = 198,
  EVENT_COMMENT_LIKED = 199,
  EVENT_COMMENT_UNLIKED = 200,

  // System Announcements
  SYSTEM_ANNOUNCEMENT_CREATED = 201,
  SYSTEM_ANNOUNCEMENT_UPDATED = 202,
  SYSTEM_ANNOUNCEMENT_DELETED = 203,

  // Settlement Management
  SETTLEMENT_RUN_CREATED = 204,
  SETTLEMENT_RUN_EXPORTED = 205,

  // Product VAT Configuration
  PRODUCT_VAT_CONFIG_CREATED = 206,
  PRODUCT_VAT_CONFIG_UPDATED = 207,
  PRODUCT_VAT_CONFIG_DELETED = 208,

  // Club Boat Management
  CLUB_BOAT_CREATED = 209,
  CLUB_BOAT_UPDATED = 210,
  CLUB_BOAT_DELETED = 211,
  CLUB_BOAT_VIEWED = 212,
  CLUB_BOATS_LISTED = 213,

  // Club Community Integration
  CLUB_COMMUNITY_CREATED = 214,
  CLUB_COMMUNITY_USER_ADDED = 215,
  CLUB_COMMUNITY_USER_REMOVED = 216,
  CLUB_COMMUNITY_ACCESS_GRANTED = 217,
  CLUB_COMMUNITY_ACCESS_DENIED = 218,
  CLUB_COMMUNITY_SYNC_SUCCESS = 219,
  CLUB_COMMUNITY_SYNC_FAILED = 220,
  CLUB_FORUM_POST_CREATED = 221,
  CLUB_FORUM_ACCESS_ATTEMPT = 222,
  // Club Member Roster
  CLUB_MEMBER_ROSTER_LISTED = 223,
  CLUB_MEMBER_ROSTER_VIEWED = 224,
  CLUB_MEMBER_ROSTER_CREATED = 226,
  CLUB_MEMBER_ROSTER_UPDATED = 227,
  CLUB_MEMBER_ROSTER_STATUS_UPDATED = 228,
  CLUB_MEMBER_ROSTER_DELETED = 229,

  // Theme Routes
  THEME_ROUTE_CREATED = 230,
  THEME_ROUTE_UPDATED = 231,
  THEME_ROUTE_DELETED = 232,
  THEME_ROUTE_PUBLISHED = 233,
  THEME_ROUTE_VIEWED = 234,
  THEME_ROUTES_LISTED = 235,
  THEME_ROUTE_APPROVAL_REQUESTED = 236,
  THEME_ROUTE_APPROVED = 237,
  THEME_ROUTE_REJECTED = 238,
  THEME_ROUTE_REVERTED = 239,
  THEME_ROUTE_UNLOCKED = 240,
  THEME_ROUTE_COMMENT_ADDED = 241,
  THEME_ROUTE_COMMENT_UPDATED = 242,
  THEME_ROUTE_COMMENT_DELETED = 243,

  // Articles
  ARTICLE_CREATED = 244,
  ARTICLE_UPDATED = 245,
  ARTICLE_DELETED = 246,
  ARTICLE_VIEWED = 247,
  ARTICLES_LISTED = 248,
  ARTICLE_STATUS_UPDATED = 249,
  ARTICLE_VERSION_PUBLISHED = 250,
  ARTICLE_VERSIONS_LISTED = 251,
  ARTICLE_IMAGE_UPLOADED = 252,
  ARTICLE_TRANSLATION_GENERATED = 253,

  // KYC Management
  KYC_CREATED = 254,
  KYC_UPDATED = 255,
  KYC_STATUS_UPDATED = 256,
  KYC_APPROVED = 257,
  KYC_REJECTED = 258,

  CREATE_EVENT = 277,
  UPDATE_EVENT = 278,
  CANCEL_EVENT = 279,
  RSVP = 280,

  AUDIT = 300,

  // DMO Registration & Invitation
  DMO_REGISTRATION_INVITATION_CREATED = 301,
  DMO_REGISTRATION_INVITATION_CANCELLED = 302,
  DMO_REGISTRATION_INVITATIONS_LISTED = 303,
  DMO_REGISTRATION_INVITATION_VIEWED = 304,
  DMO_REGISTRATION_REQUEST_CREATED = 305,
  DMO_REGISTRATION_REQUESTS_LISTED = 306,
  DMO_REGISTRATION_REQUEST_VIEWED = 307,
  DMO_REGISTRATION_REQUEST_DELETED = 308,
  DMO_REGISTRATION_TOKEN_VALIDATED = 309,

  // FAQ
  FAQ_CREATED = 310,
  FAQ_UPDATED = 311,
  FAQ_DELETED = 312,
  FAQ_HELPFUL_UPDATED = 313,
  FAQ_TRANSLATION_GENERATED = 314,
  FAQ_DRAFT_SAVED = 342,
  FAQ_TRANSLATION_PUBLISHED = 343,
  FAQ_TRANSLATION_ROLLED_BACK = 344,

  // Platform Setting
  PLATFORM_SETTING_CREATED = 315,
  PLATFORM_SETTING_UPDATED = 316,
  PLATFORM_SETTING_GENERATED = 317,

  // Testimonial
  TESTIMONIAL_CREATED = 318,
  TESTIMONIAL_UPDATED = 319,
  TESTIMONIAL_DELETED = 320,
  TESTIMONIAL_TRANSLATION_GENERATED = 321,

  ROUTING_DIAGNOSTICS = 322,

  // Notification Rule
  NOTIFICATION_RULE_UPDATED = 323,

  SERVICE_APPROVED = 324,
  SERVICE_REJECTED = 325,
  SERVICE_MODERATED = 326,

  COMMISSION_POLICY_CREATED = 327,
  COMMISSION_POLICY_UPDATED = 328,
  COMMISSION_POLICY_DEACTIVATED = 329,

  EXTERNAL_SERVICE_UPDATED = 330,

  // Subscription Trial
  TRIAL_STARTED = 332,
  TRIAL_CANCELLED = 333,
  TRIAL_CONVERSION_ATTEMPTED = 334,
  TRIAL_CONVERTED = 335,
  TRIAL_EXPIRED = 336,
  TRIAL_CONVERSION_FAILED = 337,
  TRIAL_ACTIVATED = 338,

  ENTITLEMENT_GRANT_CREATED = 350,
  ENTITLEMENT_GRANT_UPDATED = 351,
  ENTITLEMENT_GRANT_CANCELLED = 352,
  ENTITLEMENT_GRANT_EXPIRED = 353,
  SUBSCRIPTION_AUTO_RENEW_CANCELLED = 354,

  LIST_VALUE_CREATED = 345,
  LIST_VALUE_UPDATED = 346,
  LIST_VALUE_DELETED = 347,
  HARBOR_FINANCE_REPORT_EXPORTED = 348,
  BOOKING_REPORT_EXPORTED = 349,

  BUSINESS_VAT_SET = 339,
  BUSINESS_VAT_UPDATE = 340,
  BUSINESS_VAT_REMOVED = 341,

  EXTERNAL_RESERVATION_CREATED = 355,
  EXTERNAL_RESERVATION_UPDATED = 356,
  EXTERNAL_RESERVATION_RELEASED = 357,

  ICON_IMAGE_CREATED = 358,
  ICON_IMAGE_UPDATED = 359,
  ICON_IMAGE_RENAMED = 365,
  ICON_IMAGE_RETIRED = 366,
  ICON_IMAGE_REACTIVATED = 367,
  ICON_IMAGE_DELETED = 368,

  // Guest Booking Governance
  GUEST_BOOKING_GLOBAL_SETTING_UPDATED = 360,
  GUEST_BOOKING_HARBOR_OVERRIDE_UPDATED = 361,

  // Guest Booking Self-Service & Claiming
  GUEST_BOOKING_ACCESS_REQUESTED = 362,
  GUEST_BOOKING_CLAIMED = 363,
  GUEST_BOOKING_CLAIM_REJECTED = 364,
}
